import './Landing.css';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCode, faLock, faComment } from '@fortawesome/fontawesome-free-solid';

import misc from '../../misc';
const logoImage = misc.images.logoGreyF8;

export class Landing extends Component {
  render() {
    return (
      <div>
        <nav className="navbar fixed-top navbar-expand-md bg-primary navbar-dark">
          <div className="container">
            <Link
              to={this.props.auth ? '/sessions' : '/'}
              className="navbar-brand"
            >
              <img
                src={logoImage}
                width="30"
                height="30"
                className="d-inline-block align-top mr-2"
                alt="Federation"
              />
              &nbsp;Personal Trainer
            </Link>
          </div>
        </nav>

        <div className="jumbotron">
          <div className="container text-center">
            <h4 className="display-4">Personal Trainer</h4>
            <h5>Data Collection &amp; Testing</h5>
            <br />
            <p>
              <Link
                to="/auth/signup"
                className="btn btn-primary btn-lg mr-2"
                role="button"
              >
                Signup
              </Link>
              <Link
                to="/auth/login"
                className="btn btn-primary btn-lg"
                role="button"
              >
                Login
              </Link>
            </p>
          </div>
        </div>

        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col-md-4 px-4">
                <h1 className="text-center text-primary">
                  <FontAwesomeIcon icon={faCode} />
                </h1>
                <h2 className="text-center">Development</h2>
                <p className="text-muted">
                  This software is actively being developed as we work towards
                  the first public release. By participating in the Development
                  Beta and sharing your business data, you're contributing to
                  the development of the platform.
                </p>
              </div>

              <div className="col-md-4 px-4">
                <h1 className="text-center text-primary">
                  <FontAwesomeIcon icon={faLock} />
                </h1>
                <h2 className="text-center">Confidentiality</h2>
                <p className="text-muted">
                  Your information will at all times be treated as completely
                  confidential. No data shared with us will ever be made
                  available to any third parties for any reason whatsoever.
                </p>
              </div>

              <div className="col-md-4 px-4">
                <h1 className="text-center text-primary">
                  <FontAwesomeIcon icon={faComment} />
                </h1>
                <h2 className="text-center">Feedback</h2>
                <p className="text-muted">
                  Throughout this development stage and beyond, feedback on your
                  experience with this software is incredibly valuable. Please
                  don't hesitate to contact the developers and let us know how
                  we're doing.
                </p>
              </div>
            </div>
          </div>
          <br />
          <br />
        </div>

        <footer className="bg-primary pt-4 pb-2">
          <div className="container">
            <p>
              <small>&copy; 2018 Personal Trainer</small>
            </p>
          </div>
        </footer>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Landing);



// WEBPACK FOOTER //
// ./src/modules/core/components/Landing.js